module.exports = __webpack_public_path__ + "static/media/hilary-duff-win.50b2d7ac.jpg";